import { anylinkAPI } from "./anylinkAPI";

const communicationType = "auto_campaign_messages";

export const autoCampaignMessageAPI = {
  /**
   * Create digital voucher for Autocampaign
   * @param {number} campaignId
   * @returns an object containing the reward
   */
  createDigitalVoucher(autoCampaignMessageId) {
    return campaignRewardAPI.create(autoCampaignMessageId, "AutoCampaignMessage");
  },
  /**
   * Get all anylinks from a autocampaign message (AKA scope)
   * @param {number} autoCampaignMessageId
   * @returns {array} Array of anylinks ordered by priority
   */
  getAnyLinks(autoCampaignMessageId) {
    return anylinkAPI.getAnyLinks(communicationType, autoCampaignMessageId)
  },
  /**
   * Get digital voucher for Autocampaign
   * @param {number} rewardId
   * @param {number} ownerId
   * @returns an object containing the reward
   */
  getDigitalVoucher(rewardId, ownerId) {
    return campaignRewardAPI.fetch(rewardId, ownerId, 'AutoCampaignMessage');
  },
  /**
   * PUT to update anyLinks for an autocampaign message (AKA scope)
   * @param {number} autoCampaignMessageId
   * @param {array} anyLinks
   * @returns {object} status code 200 if successful or error
   */
   putUpdateAnyLinks(autoCampaignMessageId, anyLinks) {
    return anylinkAPI.putUpdateAnyLinks(communicationType, autoCampaignMessageId, anyLinks)
  }
}
